import { render, staticRenderFns } from "./wxShare_voluntaryRec.vue?vue&type=template&id=1dc1f120&scoped=true&"
import script from "./wxShare_voluntaryRec.vue?vue&type=script&lang=js&"
export * from "./wxShare_voluntaryRec.vue?vue&type=script&lang=js&"
import style0 from "./wxShare_voluntaryRec.vue?vue&type=style&index=0&id=1dc1f120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc1f120",
  null
  
)

export default component.exports